/* eslint-disable max-lines-per-function */
import React from 'react';
import { useNavigate } from 'react-router-dom';
// context and data
import useTrackPageShown from 'src/viewLayer/components/hooks/useTrackPageShown';
import useInputState from '../../hooks/useInputState';
// view components
import IdentityProviderInput from 'src/viewLayer/components/shared/Inputs/IdentityProviderInput';
import BackButton from 'src/viewLayer/components/pages/BackButton';
import TrackableButton from 'src/viewLayer/components/shared/TrackableButton';
import DataProcessingSection from './DataProcessingSection';
import './index.scss';
import { t } from 'src/viewLayer/helpers/translations';
import useB2BSessionRequest from 'src/viewLayer/components/hooks/useB2BSessionRequest';
import { useBusinessErrorPagePath } from 'src/viewLayer/navigation';

export default function LoginBusinessPage({ appType }) {
  useTrackPageShown({ appType,  pageType: 'b2b_sso_subdomain' });
  const navigate = useNavigate();
  const redirectPath = useBusinessErrorPagePath();

  const initIdentityProvider = {
    inputValue: '',
    isFocused: true
  };

  // State
  const {
    errorKey: identityProviderErrorKey,
    setErrorKey: setIdentityProviderErrorKey,
    inputValue: identityProvider,
    isFocused: identityProviderIsFocused,
    setInputValue: setIdentityProvider,
    setFocus: setIdentityProviderFocus,
    resetInputState: resetIdentityProviderState
  } = useInputState(initIdentityProvider);

  const {
    makeIdentityProviderValidationRequest,
    identityProviderValidationRequestInProgress,
    isRedirecting
  } = useB2BSessionRequest(identityProvider);

  const onSubmit = async (event) => {
    event.preventDefault();
    try {
      await makeIdentityProviderValidationRequest();
    } catch (errorKey) {
      errorKey === 'redirectToErrorPage' ?
        navigate(redirectPath, { replace: true }) :
        setIdentityProviderErrorKey(errorKey);
    }
  };

  return (
    <div className="LoginBusinessPage" data-testid="login-business-page">
      <BackButton trackingId="backbutton-business-to-email" path="business" />
      <h1>{ t('email.title') }</h1>
      <form className="sso-form" onSubmit={ onSubmit }>
        <label className="sso-form-label">{ t('login.b2b.company_identity_provider') }</label>
        <IdentityProviderInput
          clearValue={ resetIdentityProviderState }
          errorKey={ identityProviderErrorKey }
          isFocused={ identityProviderIsFocused }
          setFocus={ setIdentityProviderFocus }
          onChangeHandler={ setIdentityProvider }
          value={ identityProvider }
        />
        <div className="actions">
          <TrackableButton
            disabled={ identityProvider.length === 0 || identityProviderValidationRequestInProgress || isRedirecting }
            trackingId="identity_provider_continue"
            inProgress={ identityProviderValidationRequestInProgress || isRedirecting }
          >
            { t('email.button.continue') }
          </TrackableButton>
        </div>
      </form>
      <DataProcessingSection />
    </div>
  );
};
